import * as React from "react";
import { Alert, Badge, Box, Header, Icon, Link, SpaceBetween, Toggle, Popover } from "@amzn/awsui-components-react";
import { ALPHA_TESTING_CONFIG, FEEDBACK_COLORS } from "./chatbot.constants";

export const PathfinderAlphaTestingDisclaimerMessage: React.FC = () => (
  <b>Alpha testing mode - Answers might not be reliable</b>
);

export const DisclaimerBadge: React.FC = () => (
  <div className="disclaimer-badge">
    <Badge color="red">Disclaimer: Answers might not be reliable</Badge>
  </div>
);

interface PathfinderHeaderProps {
  isCrossInstanceEnabled?: boolean;
  onCrossInstanceToggle?: (enabled: boolean) => void;
  isAlphaTestingInstance?: boolean;
}

export const PathfinderHeader: React.FC<PathfinderHeaderProps> = ({
  isCrossInstanceEnabled = false,
  onCrossInstanceToggle,
  isAlphaTestingInstance = false
}) => (
  <Box padding={{ top: "xs", bottom: "xs" }}>
    <style>
      {`
        .${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-up svg {
          stroke: ${FEEDBACK_COLORS.positive.default} !important;
          color: ${FEEDBACK_COLORS.positive.default} !important;
        }
        .${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-down svg {
          stroke: ${FEEDBACK_COLORS.negative.default} !important;
          color: ${FEEDBACK_COLORS.negative.default} !important;
        }
        .${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-up,
        .${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-down {
          display: inline-flex;
          align-items: center;
          vertical-align: middle;
        }
        .${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-up svg,
        .${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-down svg {
          vertical-align: middle;
        }
        .disclaimer-badge {
          text-align: center;
        }
        .disclaimer-badge * {
          font-size: 18px !important;
          font-weight: 600 !important;
        }
      `}
    </style>
    <SpaceBetween size="xxs" direction="vertical">
      <Header>{isAlphaTestingInstance ? "Pathfinder Chatbot - Alpha Testing Mode" : "Pathfinder Chatbot"}</Header>
      {isAlphaTestingInstance && <DisclaimerBadge />}
      {isAlphaTestingInstance && (
        <Alert>
          We need your feedback! Use the{" "}
          <span className={`${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-up`}>
            <Icon name="thumbs-up" />
          </span>{" "}
          or{" "}
          <span className={`${ALPHA_TESTING_CONFIG.FEEDBACK_CSS_CLASS}-thumbs-down`}>
            <Icon name="thumbs-down" />
          </span>{" "}
          below to provide feedback on the quality of specific responses. Click{" "}
          <Link href={ALPHA_TESTING_CONFIG.FEEDBACK_URL} external>here</Link> to provide general feedback about the chatbot.
        </Alert>
      )}
      {onCrossInstanceToggle && (
        <SpaceBetween size="xs" direction="horizontal" alignItems="center">
          <Toggle
            onChange={({ detail }) => onCrossInstanceToggle(detail.checked)}
            checked={isCrossInstanceEnabled}
          >
            Cross Instance Query
          </Toggle>
          <Popover
            dismissButton={false}
            position="top"
            size="small"
            triggerType="custom"
            content="By default, the Pathfinder chatbot will respond based on content within your current Instance. Toggle 'Cross Instance Query' to receive answers based on content across all Instances within Pathfinder"
          >
            <Link variant="info">Info</Link>
          </Popover>
        </SpaceBetween>
      )}
    </SpaceBetween>
  </Box>
);

export const ErrorFallback: React.FC = () => (
  <div>
    <div style={{ whiteSpace: "pre-line" }}>Error loading chatbot</div>
    <div style={{ paddingTop: "10px" }}>
      <p>Please use Report a technical bug to create SIM</p>
    </div>
  </div>
);
